module.exports = __webpack_public_path__ + "static/media/18.e8aadd48.jpg";